export const RESET_STATE = 'RESET_STATE';
export const SET_LINK_CIPHER = 'SET_LINK_CIPHER';
export const SET_ACTIVE_SHARED_VIEW = 'SET_ACTIVE_SHARED_VIEW';
export const SET_APP_TYPE = 'SET_APP_TYPE';
export const SET_LINK_TYPE = 'SET_LINK_TYPE';
export const SET_LINK_DETAILS = 'SET_LINK_DETAILS';
export const SET_FETCH_LINK_DETAILS_STATUS = 'SET_FETCH_LINK_DETAILS_STATUS';
export const SET_LINK_PASSWORD = 'SET_LINK_PASSWORD';
export const SET_SETUP_LINK_PASSWORD_STATUS = 'SET_SETUP_LINK_PASSWORD_STATUS';
export const SET_LINK_RESTORE_INFO = 'SET_LINK_RESTORE_INFO';
export const SET_FETCH_LINK_RESTORE_INFO_STATUS = 'SET_FETCH_LINK_RESTORE_INFO_STATUS';
export const SET_LINK_CONTENT_ITEMS = 'SET_LINK_CONTENT_ITEMS';
export const SET_FETCH_LINK_CONTENT_ITEMS_STATUS = 'SET_FETCH_LINK_CONTENT_ITEMS_STATUS';
export const SET_LINK_ROOT_FOLDER_NAME = 'SET_LINK_ROOT_FOLDER_NAME';
